import {PortalType} from "@studyportals/domain-client";
import {defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig} from "nuxt/app";
import type {RouteLocationNormalized} from "vue-router"
import {isCatchAllRoute} from "@utils/route-helpers";
import {FilterType} from "@studyportals/omnisearch-interfaces";
import {AttendanceFilterValue} from "@studyportals/search-api-interface"; // TODO: Remove before production release
import { portalTypeBasePaths } from "@app/utils/portal-type-base-path";

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) return;

	if (!isCatchAllRoute(to) && to.params[FilterType.EDUCATION_LEVEL] === undefined) return;

	const matchedPortalType = useRuntimeConfig().public.portalType as PortalType;
	const matchedPortalTypeBasePath = matchedPortalType ? portalTypeBasePaths[matchedPortalType] : null;

	if (!matchedPortalTypeBasePath) return;

	if(matchedPortalType !== PortalType.DISTANCE_LEARNING && to.path.startsWith(matchedPortalTypeBasePath)) {
		return;
	}

	const query = { ...to.query };
	const params = to.params;

	if (matchedPortalType === PortalType.DISTANCE_LEARNING ) {
		const routePortalValue = params[FilterType.EDUCATION_LEVEL];
		const hasLegacyPortalParam = typeof routePortalValue === 'string' && routePortalValue !== 'distance-learning';
		const hasLvQuery = typeof query[FilterType.EDUCATION_LEVEL] === 'string' && query[FilterType.EDUCATION_LEVEL].length > 0;

		if (hasLegacyPortalParam && !hasLvQuery) {
			query[FilterType.EDUCATION_LEVEL] = routePortalValue;
		}

		const attendanceValue = String(query[FilterType.ATTENDANCE] || '');
		const hasOnline = attendanceValue.includes(AttendanceFilterValue.ONLINE);
		const hasBlended = attendanceValue.includes(AttendanceFilterValue.BLENDED);
		const hasOnlineOnly = query[FilterType.ATTENDANCE] === AttendanceFilterValue.ONLINE || params[FilterType.ATTENDANCE] === AttendanceFilterValue.ONLINE;
		const isOnDistanceLearningBasePath = to.path.startsWith(matchedPortalTypeBasePath);

		if (isOnDistanceLearningBasePath && hasOnline && hasBlended && !hasLegacyPortalParam) return;
		if (isOnDistanceLearningBasePath && hasOnlineOnly && !hasLegacyPortalParam) return;

		if (!hasOnlineOnly && (!hasOnline || !hasBlended)) {
			query[FilterType.ATTENDANCE] = [AttendanceFilterValue.ONLINE, AttendanceFilterValue.BLENDED].join(',');
		}
	}

	return navigateTo({path: matchedPortalTypeBasePath, query}, {redirectCode: 301});
});
